"use strict";import{IconCross100 as o}from"../src/elements/IconCross100.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-cross100",o);
//# sourceMappingURL=sp-icon-cross100.js.map
